import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import ExchangeRateRefDateMappingContMain from "presentation/view/container/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingContMain";

CommonEntrypoint(<ExchangeRateRefDateMappingContMain/>)